const termsAndConditionsDescription = {
    bindings: {},
    transclude: true,
    template:
        '<p> Copy/paste or edit the Terms &amp; Conditions in the space below. This will be visible to the channel users when they are asked to agree to the Terms &amp; Conditions the next time they log in.</p>',
};
angular
    .module('backOffice')
    .component('jhTermsAndConditionsDescription', termsAndConditionsDescription);
